// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"forgotPassword_wrapper__ArHlX"};